import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { Formik, Form } from 'formik';
import { FormikTextField } from 'formik-material-fields';
import * as Yup from 'yup';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

export default function VisitorRegistrationDialog(props) {

    const classes = useStyles();
    const [name, setName] = useState(null)
    const [email, setEmail] = useState(null)
    const [job, setJob] = useState(null)
    const [company, setCompany] = useState(null)

    let history = useHistory();

    const nameChanged = (event) => {
        setName(event.target.value)
    }

    const emailChanged = (event) => {
        setEmail(event.target.value)
    }

    const jobChanged = (event) => {
        setJob(event.target.value)
    }

    const companyChanged = (event) => {
        setCompany(event.target.value)
    }

    const saveVisitor = () => {
        setName(null);
        setEmail(null);
        setJob(null);
        setCompany(null);
        dataService.saveVisitorRegistration(name, email, job, company).then(orderId =>{
            console.log(orderId)
            history.push('/order/'+orderId)
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        props.closeDialog()
        
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            aria-labelledby="draggable-dialog-title"
            onClose={props.closeDialog}
        >
            <div className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
                {props.dialogTitle}
            </div>
            <div className={classes.dialogContext}>
                {props.dialogContext}
            </div>
            <Formik
                initialValues={{
                    name: '',
                    email: '',
                }}
                validationSchema={Yup.object().shape({
                    name: Yup.string().required('Name is required'),
                    email: Yup.string().required('Email is required').email(),
                })}
            >
                {({ isValid }) => (
                    <Form autoComplete="off" className={classes.form}>
                        <div className={classes.label}>
                            {"Full name*"}
                        </div>
                        <div className={classes.textfield}>
                            <FormikTextField id="outlined-search" name="name" label="" type="search" variant="outlined" value={name} className={classes.uiTextField} size="small" onChange={(e) => nameChanged(e)} />
                        </div>
                        <div className={classes.label}>
                            {"Email*"}
                        </div>
                        <div className={classes.textfield}>
                            <FormikTextField id="outlined-search" name="email" label="" type="search" variant="outlined" value={email} className={classes.uiTextField} size="small" onChange={(e) => emailChanged(e)} />
                        </div>

                        <div className={classes.label}>
                            {"Function"}
                        </div>
                        <div className={classes.textfield}>
                            <FormikTextField id="outlined-search" name="job" label="" type="search" variant="outlined" value={job} className={classes.uiTextField} size="small" onChange={(e) => jobChanged(e)} />
                        </div>

                        <div className={classes.label}>
                            {"Company"}
                        </div>
                        <div className={classes.textfield}>
                            <FormikTextField id="outlined-search" name="company" label="" type="search" variant="outlined" value={company} className={classes.uiTextField} size="small" onChange={(e) => companyChanged(e)} />
                        </div>
                        <div className={classes.buttons}>
                            <Button className={classes.okButton} onClick={() => saveVisitor()} disabled={!isValid || name === null || email === null}>
                                OK
                            </Button>
                        </div>

                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}



const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        height: "auto !important",
        margin: "auto",
        "& > div > div": {
            backgroundImage: 'linear-gradient(#EFEFEF,#FFFFFF)'
        },
    },
    form: {
        width: "300px",
        marginLeft: "auto",
        marginRight: "auto"
    },
    buttons: {
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        width: "235px",
        marginTop:"10px"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "50px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        fontSize: "32px !important",
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "50px",
        marginBottom: "5px",
        width: "520px"

    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingLeft: "50px",
        paddingRight: "50px",
        height: "20px",
        marginBottom: "15px"
    },
    uiTextField: {
        width: "300px",
        backgroundColor: "white",
        marginRight: "auto",
        marginLeft: "auto",
        marginBottom: "15px",
        maxHeight:"40px",
        "& .MuiFormHelperText-root.Mui-error": {
            backgroundColor: "rgb(1,1,1,0)",
            display:"contents",
        },

    },
    textField: {
        width: "300px",
        marginRight: "auto",
        marginLeft: "auto"
    },
    label: {
        color: "#000000",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        width: "300px",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "5px",
        marginBottom: "2px"
    }
}));
